import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

export const shouldForwardProp = (propName, target) => {
	if (typeof target === 'string') {
		return isPropValid(propName);
	}

	return true;
};

// Wraps an optional Testing Library wrapper so styled-components still filters props.
export const withStyleSheetManager = (Wrapper) => {
	if (!Wrapper) {
		return function StyleSheetManagerWrapper({ children }) {
			return <StyleSheetManager shouldForwardProp={shouldForwardProp}>{children}</StyleSheetManager>;
		};
	}

	return function WrapperWithStyleSheetManager(props) {
		return (
			<StyleSheetManager shouldForwardProp={shouldForwardProp}>
				<Wrapper {...props} />
			</StyleSheetManager>
		);
	};
};
